import axios from '@/libs/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libs/react-query';
import { useQuery } from '@tanstack/react-query'; //

interface Response {
  data: string;
}

//
const request = (): Promise<Response> => {
  return axios.post('getotp');
};

type QueryFnType = typeof request;
//
type UseDetailOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetOtp = ({ config }: UseDetailOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['user-otp'],
    queryFn: () => request(),
  });
};
